import { useEffect } from "react";
import { useNavigationType } from "react-router-dom";
import useQueryParams from "utils/useQueryParams";

const useSyncPageWithQuery = (setPageInfo) => {
  const { searchParams } = useQueryParams();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === "POP") {
      const pageParam = Number(searchParams.get("page")) || 1;
      setPageInfo((prev) => ({ ...prev, page: pageParam }));
    }
  }, [searchParams, setPageInfo, navigationType]);
};

export default useSyncPageWithQuery;
